<template>
  <div class="mt-5">
    <fieldset class="based-another__fieldset">
      <legend class="based-another__legend">
        <span>
          {{ $t('engineering.chromatography.method-parameters.norm-method-used-as-base') }}
        </span>
      </legend>
      <b-container fluid>
        <b-row class="my-2" align-v="end">
          <b-col cols="12">
            <label class="mb-0 d-inline-block">
              {{ $t('engineering.norm') }}*
              <s-loader
                v-if="loadingNorms"
                class="d-inline-block"
                size="xs"
              />
            </label>
             <s-input-label-edit
               v-model="basedAnotherStandardMethod.rule"
               :editable="editMode"
               :formatted-value="getRuleLabel()"
             >
             <s-select
               v-model="basedAnotherStandardMethod.rule"
               value-field="id"
               text-field="name"
               :options="normsLookup"
               @change="normChanged"
             />
            </s-input-label-edit>
          </b-col>
          <b-col cols="12">
            <label class="mb-0 mt-2 d-inline-block">
              {{ $t('engineering.method') }}*
              <s-loader
                v-if="loadingMethods"
                class="d-inline-block"
                size="xs"
              />
            </label>
             <s-input-label-edit
               v-model="basedAnotherStandardMethod.method"
               :editable="editMode"
               :formatted-value="getMethodLabel()"
             >
             <s-select
               v-model="basedAnotherStandardMethod.method"
               value-field="id"
               text-field="name"
               :disabled="!basedAnotherStandardMethod.rule"
               :options="methodsLookup"
             />
            </s-input-label-edit>
          </b-col>
        </b-row>
      </b-container>
    </fieldset>
  </div>
</template>

<script>
import Service from '@/domain/services/installation/engineering/chromatography/parametersOfMethods';

export default {
  name: 'BasedAnotherStandardMethod',
  props: {
    editMode: {
      type: Boolean,
    },
    parametersCopy: {
      type: Object,
      required: true,
    },
  },
  data: vm => ({
    normsLookup: [{ id: null, name: vm.$t('general.select') }],
    methodsLookup: [{ id: null, name: vm.$t('general.select') }],
    loadingNorms: false,
    loadingMethods: false,
  }),
  computed: {
    parametersCopyProxy: {
      get() {
        return this.parametersCopy || {};
      },
      set(value) {
        this.$emit('update:parameters-copy', value);
      },
    },
    basedAnotherStandardMethod: {
      get() {
        return this.parametersCopyProxy.basedAnotherStandardMethod || {};
      },
      set(value) {
        this.parametersCopyProxy.basedAnotherStandardMethod = value;
      },
    },
  },
  created() {
    this.getNormsLookup();
    this.getMethodsIfHaveRuleSelected();
  },
  methods: {
    normChanged(norm) {
      if (!norm) {
        this.basedAnotherStandardMethod.method = null;
        return;
      }
      this.getMethodsLookup(norm);
    },
    getMethodLabel() {
      const { rule, method } = this.basedAnotherStandardMethod;
      if (!rule || !method) return '';
      return this.$t(`enums.engineering.chromatography.methods.${rule}.${method}`);
    },
    getRuleLabel() {
      const { rule } = this.basedAnotherStandardMethod;
      if (!rule) return '';
      return this.$t(`enums.engineering.chromatography.rules.${rule}`);
    },
    getMethodsIfHaveRuleSelected() {
      const { rule } = this.basedAnotherStandardMethod;
      if (rule) {
        this.getMethodsLookup(rule);
      }
    },
    getNormsLookup() {
      this.loadingNorms = true;
      return Service.getNormsLookup()
        .then((response) => {
          const arrayWithoutDuval = response.filter(it => it.id !== 'duval');
          this.normsLookup = this.normsLookup.concat(arrayWithoutDuval);
        })
        .finally(() => {
          this.loadingNorms = false;
        });
    },
    getMethodsLookup(norm) {
      this.loadingMethods = true;
      const params = { norm };
      const { assetModuleId } = this.$route.params;
      return Service.getMethodsLookup(assetModuleId, params)
        .then((response) => {
          this.methodsLookup = [
            { id: null, name: this.$t('general.select') },
            ...response,
          ];
        })
        .finally(() => {
          this.loadingMethods = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.based-another
  &__fieldset
    border: 1px solid var(--color-border-regular)
  &__legend
    font-weight: 400
    font-size: 1.1rem
    margin-left: 10px
    padding: 0 5px 0 5px
    width: auto
</style>
